import React from "react"
import { FlagsIconSeeker, IconSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material"
import { legacyColors } from "@palette"
import AppBrandMark from "./BrandMark"


export default function AppRetailerBlock({ retailer, country, icon, provider, mainName, sx={} }) {
	return <><Box sx={{ display: 'flex', alignItems: 'center', gap: .5, minWidth: 0, ...sx }}>
		{/* The site's logo: the one the API sends, else the one its name gives (initial when there is none) */}
		{(!!retailer || !!icon) && <AppBrandMark name={retailer} icon={icon}/>}
		<FlagsIconSeeker countryName={country} />
		<Typography variant="subtitle2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{retailer}</Typography>
		{ provider && <IconSeeker icon='square-parking' color={legacyColors.cssBlue} iconWeight="light" sx={{ fontSize: '18px' }} /> }
	</Box>
	<Box>
		{ mainName && <Typography sx={{ fontSize: '0.8rem', color: legacyColors.cssGray, ml: '1rem' }}>
			Comparing vs <Typography variant='span' sx={{ fontStyle: 'italic', fontWeight: '600' }}>{ mainName }</Typography>
		</Typography> }
	</Box></>
}